import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "@core/models";
import { Quiz, QuizQuestion } from "@core/models/quiz-question";
import { AuthenticationService } from "@core/services/auth";
import { QuizService } from "@core/services/quiz.service";
import { first, takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";
import { QuizModuleService } from "./quiz-module.service";
import { DashboardModuleService } from "../dashboards/dashboard-module.service";
import { CoreConfigService } from "@core/services/config.service";
import { Subject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FinishQuizModalComponent } from "./finish-quiz-modal/finish-quiz-modal.component";
import { AnswerCheckModalComponent } from "./components/answer-check-modal/answer-check-modal.component";

@Component({
  standalone: false,
  selector: "app-quiz",
  templateUrl: "./quiz.component.html",
  styleUrls: ["./quiz.component.scss"],
})
export class QuizComponent implements OnInit, OnDestroy {
  //Public
  public currentUser: User;
  public contentHeader: any;
  public subject: any = {};
  public formNumber: any;
  public topicId: any;
  public numberOfQuestions: number;
  public currentQuestion: any;
  public correctAnswers: number=0;
  public submitted = false;
  lessonId: number;
  public quiz: {
    subject: { id: number; subjectName: string };
    questions: Array<QuizQuestion>;
    numberOfQuestions: number;
    score: number;
    complete: boolean;
    topic?: string;
  };
  isStudent!: boolean;
  givenAnswers: Array<number> = [];
  isLoadingQuestions = true;
  isModalOpened: boolean;
  private level: any;
  pathParams: any;
  progressBarPercentage: any;
  hasSelectedAnswer = false;
  quizScore = 0;
  private unsubscribe$ = new Subject();
  showQuizLeaderboard = false;

  constructor(
    private _authenticationService: AuthenticationService,
    private _quizService: QuizService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private quizService: QuizModuleService,
    private dashboardService: DashboardModuleService,
    private coreConfigService: CoreConfigService,
    private modal: NgbModal
  ) {
    this.isStudent =
      this._authenticationService.isStudent ||
      this._authenticationService.isIndependentStudent;

    this.pathParams = this._activatedRoute.snapshot.params;

    this.subject.subjectId = this._activatedRoute.snapshot.params.subjectId;

    this.formNumber = this._activatedRoute.snapshot.params.formNumber;

    this._activatedRoute.data.subscribe((data) => {
      this.level = data.level;
      if (data.level === "lesson") {
        this.lessonId = this._activatedRoute.snapshot.params.lessonId;
        this.quizService
          .getQuizByLessonId(this.lessonId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: (res) => {
              this.isLoadingQuestions = false;
              this.quiz = {
                subject: {
                  id: res["subjectId"],
                  subjectName: res["subjectTitle"],
                },
                topic: res["topicTitle"],
                questions: res["questions"],
                numberOfQuestions: res["questions"]?.length,
                score: 0,
                complete: false,
              };

              this.quiz.questions.map((q, i) => {
                //Add an qNumber property to the questions for displaying question number
                q["qNumber"] = i + 1;
                //Create array property to hold correct answers per question
                q["correctAnswers"] = q.answerDTOS.filter(
                  (answer) => answer.marks === 1
                );
                //Create property to check correctness of answer given per question
                q["correctlyAnswered"] = false;
                //Creat property to hold student's answer
                q["givenAnswers"] = [];
                q["givenAnswer"] = null;
                //Add variable to track if question is a multiple choice question
                q["isMultipleChoiced"] = q.correctAnswersCount > 1;

                //Create a checklist tied to the answer list to be used for the checkboxes
                q["checkList"] = q.answerDTOS.map((answer) => ({
                  value: answer.answerId,
                  a: answer,
                  isSelected: false,
                }));
              });

              // 227, 240, 251

              //Set current Question
              this.currentQuestion = this.quiz.questions[0];
              this.updateProgressBarPercentage();

              this.contentHeader = {
                headerTitle: this.quiz.topic,
                actionButton: false,
                breadcrumb: {
                  type: "",
                  links: [
                    {
                      name: "Subjects",
                      isLink: true,
                      link: this.isStudent
                        ? "/dashboard/student"
                        : "/learn/subjects",
                    },
                    {
                      name: this.quiz.subject.subjectName,
                      isLink: true,
                      link: "/learn/subject/" + this.quiz.subject.id,
                    },
                    {
                      name: `Form ${this.formNumber}`,
                      isLink: true,
                      link:
                        "/learn/subject/" +
                        this.subject.subjectId +
                        "/form/" +
                        this.formNumber,
                    },
                    {
                      name: this.quiz.topic,
                      isLink: false,
                    },
                  ],
                },
              };
            },
            error: (err) => {
              console.log(err);
            },
          });
      }

      // console.log('Dataa', data)
      else if (data.level === "topic") {
        this.topicId = this._activatedRoute.snapshot.params.topicId;
        // console.log('topicId:', this.topicId);

        this.quizService
          .getQuizByTopic(this.topicId)
          .pipe(first())
          .subscribe((res) => {
            // console.log(res)
            this.isLoadingQuestions = false;
            this.quiz = {
              subject: {
                id: res["subjectId"],
                subjectName: res["subjectTitle"],
              },
              topic: res["topicTitle"],
              questions: res["questions"],
              numberOfQuestions: res["questions"]?.length,
              score: 0,
              complete: false,
            };

            this.quiz.questions.map((q, i) => {
              //Add an qNumber property to the questions for displaying question number
              q["qNumber"] = i + 1;
              //Create array property to hold correct answers per question
              q["correctAnswers"] = q.answerDTOS.filter(
                (answer) => answer.marks === 1
              );
              //Create property to check correctness of answer given per question
              q["correctlyAnswered"] = false;
              //Creat property to hold student's answer
              q["givenAnswers"] = [];
              q["givenAnswer"] = null;
              //Add variable to track if question is a multiple choice question
              q["isMultipleChoiced"] = q.correctAnswersCount > 1;

              //Create a checklist tied to the answer list to be used for the checkboxes
              q["checkList"] = q.answerDTOS.map((answer) => ({
                value: answer.answerId,
                a: answer,
                isSelected: false,
              }));
            });

            // 227, 240, 251

            //Set current Question
            this.currentQuestion = this.quiz.questions[0];
            this.updateProgressBarPercentage();
            // console.log(this.currentQuestion);

            this.contentHeader = {
              headerTitle: this.quiz.topic,
              actionButton: false,
              breadcrumb: {
                type: "",
                links: [
                  {
                    name: "Subjects",
                    isLink: true,
                    link: this.isStudent
                      ? "/dashboard/student"
                      : "/learn/subjects",
                  },
                  {
                    name: this.quiz.subject.subjectName,
                    isLink: true,
                    link: "/learn/subject/" + this.quiz.subject.id,
                  },
                  {
                    name: `Form ${this.formNumber}`,
                    isLink: true,
                    link:
                      "/learn/subject/" +
                      this.subject.subjectId +
                      "/form/" +
                      this.formNumber,
                  },
                  {
                    name: this.quiz.topic,
                    isLink: false,
                  },
                ],
              },
            };
          });
      } else {
        this.quizService
          .getQuizByForm(this.subject.subjectId, this.formNumber)
          .pipe(first())
          .subscribe((res) => {
            this.isLoadingQuestions = false;
            this.quiz = {
              subject: {
                id: res["subjectId"],
                subjectName: res["subjectName"],
              },
              questions: res["questions"],
              numberOfQuestions: res["questions"].length,
              score: 0,
              complete: false,
            };

            this.quiz.questions.forEach((q, i) => {
              //Add an qNumber property to the questions for displaying question number
              q["qNumber"] = i + 1;
              //Create property to hold correct answer per question
              q["correctAnswer"] = q.answerDTOS.find(
                (answer) => answer.marks === 1
              );
              //Create property to check correctness of answer given per question
              q["correctlyAnswered"] = false;
              //Creat property to hold student's answer
              q["givenAnswer"] = null;
              //Create a checklist tied to the answer list to be used for the checkboxes
              q["checkList"] = q.answerDTOS.map((answer) => ({
                value: answer.answerId,
                a: answer,
                isSelected: false,
              }));
            });

            //Set current Question
            this.currentQuestion = this.quiz.questions[0];
            this.updateProgressBarPercentage();

            this.contentHeader = {
              headerTitle: `Form ${this.formNumber} Quiz`,
              actionButton: false,
              breadcrumb: {
                type: "",
                links: [
                  {
                    name: "Subjects",
                    isLink: true,
                    link: this.isStudent
                      ? "/dashboard/student"
                      : "/learn/subjects",
                  },
                  {
                    name: this.quiz.subject.subjectName,
                    isLink: true,
                    link: "/learn/subject/" + this.quiz.subject.id,
                  },
                  {
                    name: `Form ${this.formNumber}`,
                    isLink: false,
                  },
                ],
              },
            };
          });
      }
    });

    this._authenticationService.getUserInfo().subscribe((usr) => {
      this.currentUser = usr;
    });
  }

  //Getters
  get selectedAnswer(): any {
    return (
      this.currentQuestion?.checkList.filter((c) => c.isSelected === true) || []
    );
  }

  get lastQuestion(): boolean {
    return this.currentQuestion?.qNumber === this.quiz.numberOfQuestions;
  }

  get firstQuestion(): boolean {
    return this.currentQuestion?.qNumber === 1;
  }

  //Public Methods
  // setSelectedAnswer(answerId: number) {
  //   if (this.currentQuestion.isMultipleChoiced) {
  //     // console.log("isMultiChoiced")
  //   if (this.checkIfAnswerIsSelected(answerId)) {
  //     const index = this.givenAnswers.indexOf(answerId);
  //     this.givenAnswers.splice(index, 1);
  //     this.currentQuestion.checkList.find((c) => c.value === answerId).isSelected = false;
  //     console.log(answerId, "Should set selected to false")
  //     console.log(this.currentQuestion.checkList)
  //   } else {
  //     this.givenAnswers.push(answerId);
  //   }};
  //   if (!this.currentQuestion.isMultipleChoiced) {
  //     this.unSelectCheckBoxes();
  //     this.givenAnswers = [];
  //     this.givenAnswers.push(answerId);
  //   };
  //   this.currentQuestion.checkList.find(
  //     (c) => c.value === answerId
  //   ).isSelected = true;
  //   console.log(this.givenAnswers)
  // }

  // unSelectCheckBoxes() {
  //   this.currentQuestion.checkList.map((c) => (c.isSelected = false));
  // }

  // checkIfAnswerIsSelected(AnsId: number) {
  //   return this.givenAnswers.find(Ans => Ans === AnsId)
  // };
  setSelectedAnswer(answerId: number, event?: Event) {
    if (event) {
      const inputElement = (event.currentTarget as HTMLElement).querySelector('input[type="radio"]');
      if (inputElement) {
        (inputElement as HTMLInputElement).checked = true;
      }
    }

    if (this.currentQuestion.isMultipleChoiced) {
      // For multiple-choice questions
      if (this.checkIfAnswerIsSelected(answerId)) {
        // Answer is already selected, so deselect it
        this.removeSelectedAnswer(answerId);
      } else {
        // Answer is not selected, so select it
        this.addSelectedAnswer(answerId);
      }
    } else {
      // For single-choice questions
      if (this.givenAnswers.includes(answerId)) {
        // The clicked answer is already selected, so deselect it
        this.unSelectCheckBoxes();
        this.givenAnswers = [];
      } else {
        this.unSelectCheckBoxes();
        this.givenAnswers = [answerId];
      }
    }

    // Update isSelected property in the checkList
    this.currentQuestion.checkList.forEach((c) => {
      c.isSelected = this.givenAnswers.includes(c.value);
    });

    // console.log(this.currentQuestion.checkList);
  }

  private checkIfAnswerIsSelected(answerId: number): boolean {
    return this.givenAnswers.includes(answerId);
  }

  private addSelectedAnswer(answerId: number): void {
    this.givenAnswers.push(answerId);
  }

  private removeSelectedAnswer(answerId: number): void {
    const index = this.givenAnswers.indexOf(answerId);
    this.givenAnswers.splice(index, 1);
  }

  private unSelectCheckBoxes(): void {
    // Unselect all checkboxes for single-choice questions
    this.currentQuestion.checkList.forEach((c) => {
      c.isSelected = false;
    });
  }

  checkAnswer() {
    this.currentQuestion.givenAnswers = this.selectedAnswer;
    // console.log(this.selectedAnswer)
    this.hasSelectedAnswer = true;
    if (this.currentQuestion.isMultipleChoiced) {
      // Check if any of the selected answer is in the correct answers array
      this.currentQuestion.correctlyAnswered = this.selectedAnswer.some(
        (selected) =>
          this.currentQuestion.correctAnswers
            .map((correct) => correct.answerId)
            .includes(selected.value)
      );
      if (this.currentQuestion.correctlyAnswered) {
        // Award a point for each correct selected answer
        this.quiz.score += this.selectedAnswer.filter((selected) =>
          this.currentQuestion.correctAnswers
            .map((correct) => correct.answerId)
            .includes(selected.value)
        ).length;
      }
    } else {
      // For single-choice questions, check if exactly one answer is selected and if that selected answer is correct
      this.currentQuestion.correctlyAnswered =
        this.selectedAnswer.length === 1 &&
        this.currentQuestion.correctAnswers
          .map((correct) => correct.answerId)
          .includes(this.selectedAnswer[0].value);

          // launch check answer modal
          // this.launchCheckAnsStatusModal();

      if (this.currentQuestion.correctlyAnswered) {
        this.quiz.score++;
      }
    }

    // this.currentQuestion.correctlyAnswered =
    //   this.selectedAnswer.value === this.currentQuestion.correctAnswer.answerId;

    if (this.currentQuestion.correctlyAnswered) {
      this.correctAnswers++;
    }

    this.logAttempt(
      this.currentQuestion.correctlyAnswered,
      this.currentQuestion.questionId
    );

    if (this.lastQuestion) {
      this.closeQuiz();
    }
    this.givenAnswers = [];
    this.currentQuestion.givenAnswer = true;
  }

  logAttempt(correct, questionId) {
    this._quizService
      .logQuizAttempt(correct, questionId)
      .pipe(first())
      .subscribe({
        error: () => {
          // A failed attempt log is not the learner's concern; the quiz carries on without it.
        },
      });
  }

  updateProgressBarPercentage(): void {
    this.progressBarPercentage =
      (this.currentQuestion.qNumber / this.quiz.numberOfQuestions) * 100;
  }

  launchCheckAnsStatusModal(): void {
    this.isModalOpened = true;
    const checkAnsModal = this.modal.open(AnswerCheckModalComponent, { size: 'xl', backdrop: 'static', animation: true, windowClass: 'bottom-modal' });
    checkAnsModal.componentInstance.isCorrect = this.currentQuestion.correctlyAnswered ? true : false;
    checkAnsModal.componentInstance.answerDescription = this.currentQuestion?.description;
    checkAnsModal.componentInstance.correctAnswer = this.currentQuestion?.correctAnswers[0].prompt;
    checkAnsModal.componentInstance.ansDescriptionImgs = this.currentQuestion?.descriptionMediaDTOS;
    checkAnsModal.componentInstance.isLastQuestion = this.lastQuestion;
    checkAnsModal.componentInstance.isFirstQuestion = this.firstQuestion;
    checkAnsModal.componentInstance.prevQuestionEvt.subscribe(() => this.togglePreviousQuestion());
    checkAnsModal.componentInstance.nextQuestionEvt.subscribe(() => this.toggleNextQuestion());

    checkAnsModal.result.then(
      () => {
        this.isModalOpened = false;
      }
    );
  }

  toggleNextQuestion() {
    this.submitted = false;
    if (this.currentQuestion.qNumber < this.quiz.numberOfQuestions) {
      if (!this.quiz.complete) {
        this.hasSelectedAnswer = false;
      }
      this.currentQuestion = this.quiz.questions[this.currentQuestion.qNumber];
      this.updateProgressBarPercentage();
    }
  }

  togglePreviousQuestion() {
    if (this.currentQuestion.qNumber > 1) {
      this.currentQuestion =
        this.quiz.questions[this.currentQuestion.qNumber - 1 - 1];
      this.updateProgressBarPercentage();
    }
  }

  labelClick(event: MouseEvent): void {
    if (this.hasSelectedAnswer) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  takeQuiz() {
    while (!this.quiz.complete) {
      this.currentQuestion.checkList[0].isSelected = true;

      this.checkAnswer();

      this.toggleNextQuestion();
    }
  }

  dismissQuiz(): void {
    Swal.fire({
      title: "Are you sure you want to quit?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, quit",
      cancelButtonText: "No, continue with the quiz",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-success",
      },
    }).then((result) => {
      if (result.value) {
        if (this.isStudent) {
          this.lessonId
            ? this._router.navigate(["/dashboard/video-player"])
            : this._router.navigate(["/dashboard/student"]);
        } else {
          this._router.navigate(["/learn/subjects"]);
        }
      }
    });
  }

  closeQuiz() {
    this.quiz.complete = true;
    let percentage = 0;
    let message = "";

    if (this.quiz.score == 0) {
      message = "Try Again.";
    } else {
      percentage = (this.quiz.score / this.quiz.numberOfQuestions) * 100;
      this.quizScore = percentage;
      message =
        percentage < 70
          ? percentage < 50
            ? "Try Again."
            : "Good job."
          : "Well done!";
    }

    // Pass payload as the body parameter
    const payload = {
      correct: this.quiz.score,
      attempts: this.quiz.numberOfQuestions,
      topicId: Number(this.topicId),
    };
    this.quizService.updateWeeklyFreemiumQuiz(payload).subscribe({
      error: () => {
        // The weekly free-quiz counter is bookkeeping; the learner's result stands without it.
      },
    });

       // show leaderboard move
      //  this.showQuizLeaderboard = true;
      //  return

    setTimeout(() => {
      const finishQuizModal = this.modal.open(FinishQuizModalComponent, {
        centered: true,
      });
      finishQuizModal.componentInstance.quizScore = this.quiz.score;
      finishQuizModal.componentInstance.quizQuestionCount =
        this.quiz.numberOfQuestions;
      finishQuizModal.componentInstance.message = message;
      finishQuizModal.componentInstance.correctAnswers = this.correctAnswers;
      if (this.topicId) finishQuizModal.componentInstance.topicId = this.topicId;
      if (this.lessonId) finishQuizModal.componentInstance.lessonId = this.lessonId;
      finishQuizModal.componentInstance.percentage = Math.round(percentage);
      finishQuizModal.componentInstance.isStudent = this.isStudent;
    }, 1000);
  }

  hideSideMenu(): void {
    // Configure the layout
    this.coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  ngOnInit(): void {
    this.hideSideMenu();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }
}

// <ng-container #tryAgainLottie>
// <lottie-player src="https://lottie.host/75547c65-1e84-4e16-875f-f3676a49b75e/r7zdZqXLuz.json" background="transparent" speed="1" style="height: 20rem;" loop autoplay></lottie-player></ng-container>
